import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from "sweetalert2";
import { baseUrl } from '../components/BaseUrl';
import { paystackUrl } from '../components/PaystackUrl';
import { Button, Modal, Spinner, Card, Badge } from 'react-bootstrap';
import { MyProSidebarProvider } from "../components/SidebarContext";
import TopBar from '../components/Topbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber } from 'react-phone-number-input';
import moment from 'moment';
import logo from '../assets/img/codeflare-app.webp';
import { 
  User, 
  Edit, 
  Camera, 
  Mail, 
  Phone, 
  BookOpen, 
  CreditCard, 
  Calendar,
  CheckCircle,
  XCircle
} from 'react-feather';
import '../App.css';

const CLOUD_NAME = "dqy22jr2i"
const PRESET_NAME = "codefussion"

const Profile = () => {
  const [profile, setProfile] = useState({
    data: [],
    status: '',
    hasImage: false,
    track: '',
    paymentDate: '',
    dateEnrolled: []
  });
  
  const [loading, setLoading] = useState({
    profile: false,
    main: false,
    upload: false,
    update: false
  });
  
  const [ui, setUi] = useState({
    showUploadModal: false,
    showUpdateModal: false,
    passwordVisible: false,
    disabled: false
  });
  
  const [form, setForm] = useState({
    file: null,
    fileName: "",
    preview: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: ""
  });

  const token = localStorage.getItem("codefussion-login-token");

  // Modal handlers
  const toggleModal = (modalName, show) => {
    setUi(prev => ({ ...prev, [modalName]: show }));
  };

  // Form handlers
  const handleFormChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFormChange('fileName', file);
      handleFormChange('preview', URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    initializeProfile();
  }, []);

  const initializeProfile = async () => {
    await Promise.all([
      getProfile(),
      // getUserPayment(),
      fetchEnrollment()
    ]);
  };

  const validateForm = () => {
    const { firstName, lastName, email, phone } = form;
    const storedFirstName = localStorage.getItem("codefussion-student-first-name");
    const storedLastName = localStorage.getItem("codefussion-student-last-name");
    const storedEmail = localStorage.getItem("codefussion-student-email");
    const storedPhone = localStorage.getItem("codefussion-student-phone");

    if (!firstName && !storedFirstName) {
      showError("Empty Submission", "Please enter your first name");
      return false;
    }
    if (!lastName && !storedLastName) {
      showError("Empty Submission", "Please enter your last name");
      return false;
    }
    if (!email && !storedEmail) {
      showError("Empty Submission", "Please enter your email");
      return false;
    }
    if (!phone && !storedPhone) {
      showError("Empty Submission", "Please enter your phone number");
      return false;
    }
    return true;
  };

  const showError = (title, text) => {
    Swal.fire({
      title,
      text,
      icon: "error",
      confirmButtonText: "OK",
      backdrop: `rgba(143, 70, 0, 0.3)`
    });
  };

  const showSuccess = (title, text, callback = null) => {
    Swal.fire({
      title,
      text,
      icon: "success",
      confirmButtonText: "OK",
      backdrop: `rgba(34, 197, 94, 0.3)`
    }).then(() => {
      if (callback) callback();
    });
  };

  const updateProfile = async () => {
    if (!validateForm()) return;

    setLoading(prev => ({ ...prev, update: true }));
    setUi(prev => ({ ...prev, disabled: true }));

    try {
      const userData = {
        first_name: form.firstName?.trim() || localStorage.getItem("codefussion-student-first-name"),
        last_name: form.lastName?.trim() || localStorage.getItem("codefussion-student-last-name"),
        email: form.email?.trim() || localStorage.getItem("codefussion-student-email"),
        phone: form.phone || localStorage.getItem("codefussion-student-phone"),
      };

      const response = await axios.post(`${baseUrl}update-profile.php`, userData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      });

      if (response.data.message === "profile updated.") {
        showSuccess("Success", "Profile updated successfully", () => {
          window.location.replace("/logout");
        });
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      showError("Error", "Error updating record. Please try again later.");
    } finally {
      setLoading(prev => ({ ...prev, update: false }));
      setUi(prev => ({ ...prev, disabled: false }));
    }
  };

  const getProfile = async () => {
    setLoading(prev => ({ ...prev, profile: true }));
    
    try {
      const userData = { email: localStorage.getItem("codefussion-student-email") };
      const response = await axios.post(`${baseUrl}get-profile.php`, userData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      });

      if (response.data.status === 1) {
        showError("Error", "Error loading profile data");
      } else {
        setProfile(prev => ({ ...prev, data: response.data }));
      }
    } catch (error) {
      showError("Error", "Error loading profile data");
    } finally {
      setLoading(prev => ({ ...prev, profile: false }));
    }
  };

  const fetchEnrollment = async () => {
    setLoading(prev => ({ ...prev, main: true }));
    
    try {
      const userData = { email: localStorage.getItem("codefussion-student-email") };
      const response = await axios.post(`${baseUrl}get-enrolled-student.php`, userData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      });

      if (response.data.status === 0) {
        showError("Error", "An error occurred while fetching enrollment data");
      } else {
        response.data.forEach(item => {
          setProfile(prev => ({ 
            ...prev, 
            track: item.track_enrolled,
            dateEnrolled: item.date_enrolled 
          }));
        });
      }
    } catch (error) {
      showError("Error", "An error occurred while fetching enrollment data");
    } finally {
      setLoading(prev => ({ ...prev, main: false }));
    }
  };

  const uploadProfileImage = async () => {
    if (!form.fileName) {
      showError("Empty", "Please select a profile image");
      return;
    }

    setLoading(prev => ({ ...prev, upload: true }));
    setUi(prev => ({ ...prev, disabled: true }));

    try {
      const formData = new FormData();
      formData.append("file", form.fileName);
      formData.append("cloud_name", CLOUD_NAME);
      formData.append("upload_preset", PRESET_NAME);

      const cloudResponse = await fetch("https://api.cloudinary.com/v1_1/dqy22jr2i/upload", {
        method: 'POST',
        body: formData
      });
      
      const cloudData = await cloudResponse.json();
      await saveImageToDatabase(cloudData.secure_url);
      
    } catch (error) {
      showError("Error", "Error uploading image");
    }
  };

  const saveImageToDatabase = async (imageUrl) => {
    try {
      const userData = {
        email: localStorage.getItem("codefussion-student-email"),
        image: imageUrl,
      };

      const response = await axios.post(`${baseUrl}upload-image.php`, userData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      });

      if (response.data.status === 1) {
        showSuccess("Success", "Profile image uploaded successfully", () => {
          toggleModal('showUploadModal', false);
          getProfile();
        });
      } else {
        throw new Error("Upload failed");
      }
    } catch (error) {
      showError("Error", "Error uploading image");
    } finally {
      setLoading(prev => ({ ...prev, upload: false }));
      setUi(prev => ({ ...prev, disabled: false }));
    }
  };

  const ProfileImage = () => {
    if (loading.profile) {
      return <Spinner animation="border" variant="primary" />;
    }

    return (
      <div className="profile-image-section text-center">
        <div className="profile-image-container">
          <img 
            src={profile.hasImage ? profile.data[0]?.profile_photo : logo} 
            alt="Profile" 
            className="profile-image"
          />
          <button 
            onClick={() => toggleModal('showUploadModal', true)}
            className="edit-image-btn"
          >
            <Camera size={16} />
          </button>
        </div>
        <h3 className="profile-name mt-3">
          {`${localStorage.getItem("codefussion-student-first-name")} ${localStorage.getItem("codefussion-student-last-name")}`}
        </h3>
        <div className="profile-contact">
          <div className="contact-item">
            <Phone size={16} />
            <span>{localStorage.getItem("codefussion-student-phone")}</span>
          </div>
          <div className="contact-item">
            <Mail size={16} />
            <span>{localStorage.getItem("codefussion-student-email")}</span>
          </div>
        </div>
      </div>
    );
  };

  const InfoCard = ({ icon, title, value, status, className = "" }) => (
    <div className={`info-card ${className}`}>
      <div className="info-header">
        {icon}
        <span className="info-title">{title}</span>
      </div>
      <div className={`info-value ${status === 'active' ? 'text-success' : 'text-muted'}`}>
        {value || 'Not set'}
      </div>
    </div>
  );

  if (localStorage.getItem("codefussion-login-token") === null) {
    window.location.replace("/login");
    return null;
  }

  return (
    <MyProSidebarProvider>
      <div className="profile-page">
        <TopBar />
        
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="page-title">My Profile</h1>
                <Button 
                  variant="primary" 
                  onClick={() => toggleModal('showUpdateModal', true)}
                  className="modern-btn"
                >
                  <Edit size={18} className="me-2 text-light" />
                  Edit Profile
                </Button>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Profile Card */}
            <div className="col-lg-4 col-md-6 mb-4">
              <Card className="profile-card">
                <Card.Body className="p-4">
                  <ProfileImage />
                </Card.Body>
              </Card>
            </div>

            {/* General Information */}
            <div className="col-lg-8 col-md-6">
              <Card className="info-card-main">
                <Card.Header className="card-header-modern">
                  <BookOpen size={20} className="me-2" />
                  General Information
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <InfoCard
                        icon={<User size={18} />}
                        title="First Name"
                        value={localStorage.getItem("codefussion-student-first-name")}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <InfoCard
                        icon={<User size={18} />}
                        title="Last Name"
                        value={localStorage.getItem("codefussion-student-last-name")}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <InfoCard
                        icon={<BookOpen size={18} />}
                        title="Active Tracks"
                        value={profile.track}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <InfoCard
                        icon={profile.status === "Active" ? <CheckCircle size={18} /> : <XCircle size={18} />}
                        title="Subscription Status"
                        value={profile.status}
                        status={profile.status === "Active" ? "active" : "inactive"}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <InfoCard
                        icon={<Calendar size={18} />}
                        title="Next Payment Date"
                        value={profile.paymentDate}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <InfoCard
                        icon={<CreditCard size={18} />}
                        title="Enrollment Date"
                        value={profile.dateEnrolled}
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>

        {/* Upload Image Modal */}
        <Modal show={ui.showUploadModal} onHide={() => toggleModal('showUploadModal', false)} centered>
          <Modal.Header className="modern-modal-header">
            <Modal.Title>
              <Camera className="me-2" />
              Upload Profile Picture
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="file-upload-area">
              <input 
                type="file" 
                accept="image/png, image/jpeg, image/jpg" 
                onChange={handleFileChange} 
                className="file-input"
              />
              <div className="upload-placeholder">
                <Camera size={48} />
                <p>Click to select profile image</p>
              </div>
            </div>
            {form.preview && (
              <div className="image-preview mt-3">
                <img src={form.preview} alt="Preview" className="preview-image" />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="modern-modal-footer">
            <Button 
              variant="outline-secondary" 
              onClick={() => toggleModal('showUploadModal', false)}
            >
              Cancel
            </Button>
            <Button 
              variant="primary" 
              onClick={uploadProfileImage}
              disabled={ui.disabled || !form.fileName}
            >
              {loading.upload ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : null}
              {loading.upload ? "Uploading..." : "Upload Image"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Update Profile Modal */}
        <Modal show={ui.showUpdateModal} onHide={() => toggleModal('showUpdateModal', false)} centered>
          <Modal.Header className="modern-modal-header">
            <Modal.Title>
              <Edit className="me-2" />
              Update Profile
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">First Name</label>
                <input 
                  type="text" 
                  className="form-control modern-input"
                  defaultValue={localStorage.getItem("codefussion-student-first-name")}
                  onChange={(e) => handleFormChange('firstName', e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Last Name</label>
                <input 
                  type="text" 
                  className="form-control modern-input"
                  defaultValue={localStorage.getItem("codefussion-student-last-name")}
                  onChange={(e) => handleFormChange('lastName', e.target.value)}
                />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Email</label>
                <input 
                  type="email" 
                  disabled
                  className="form-control modern-input"
                  defaultValue={localStorage.getItem("codefussion-student-email")}
                />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Phone Number</label>
                <PhoneInput
                  international
                  defaultCountry="NG"
                  className="modern-phone-input"
                  value={localStorage.getItem("codefussion-student-phone")}
                  onChange={(value) => handleFormChange('phone', value)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modern-modal-footer">
            <Button 
              variant="outline-secondary" 
              onClick={() => toggleModal('showUpdateModal', false)}
            >
              Cancel
            </Button>
            <Button 
              variant="primary" 
              onClick={updateProfile}
              disabled={ui.disabled}
            >
              {loading.update ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : null}
              {loading.update ? "Updating..." : "Update Profile"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* <Footer /> */}
      </div>

      <style jsx>{`
        .profile-page {
          background: #f8f9fa;
          min-height: 100vh;
        }
        
        .page-title {
          color: #2d3748;
          font-weight: 700;
          font-size: 2rem;
        }
        
        .profile-card, .info-card-main {
          border: none;
          border-radius: 16px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        
        .profile-card:hover, .info-card-main:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        }
        
        .profile-image-container {
          position: relative;
          display: inline-block;
        }
        
        .profile-image {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          object-fit: cover;
          border: 4px solid #e2e8f0;
        }
        
        .edit-image-btn {
          position: absolute;
          bottom: 8px;
          right: 8px;
          width: 18px;
          aspect-ratio: 1;
          border-radius: 50%;
          border: none;
          background: #3182ce;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          padding: 0;
        }
        
        .edit-image-btn:hover {
          background: #2c5aa0;
          transform: scale(1.1);
        }
        
        .profile-name {
          color: #2d3748;
          font-weight: 600;
          margin-bottom: 1rem;
        }
        
        .profile-contact {
          text-align: left;
          margin-top: 1rem;
        }
        
        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
          color: #4a5568;
        }
        
        .contact-item svg {
          margin-right: 0.5rem;
          color: #718096;
        }
        
        .info-card {
          background: white;
          padding: 1.5rem;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
        }
        
        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
        }
        
        .info-title {
          font-weight: 600;
          color: #4a5568;
          margin-left: 0.5rem;
        }
        
        .info-value {
          font-size: 1.1rem;
          font-weight: 600;
          color: #2d3748;
        }
        
        .card-header-modern {
          background: white;
          border-bottom: 1px solid #e2e8f0;
          font-weight: 600;
          color: #2d3748;
          display: flex;
          align-items: center;
        }
        
        .modern-btn {
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          color: white;
          border: none;
          background: #3182ce;
          transition: all 0.2s ease;
        }
        
        .modern-btn:hover {
          background: #2c5aa0;
          transform: translateY(-1px);
        }
        
        .modern-modal-header {
          background: #f7fafc;
          border-bottom: 1px solid #e2e8f0;
        }
        
        .modern-modal-footer {
          background: #f7fafc;
          border-top: 1px solid #e2e8f0;
        }
        
        .modern-input {
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          padding: 0.75rem;
          transition: all 0.2s ease;
        }
        
        .modern-input:focus {
          border-color: #3182ce;
          box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
        }
        
        .file-upload-area {
          border: 2px dashed #e2e8f0;
          border-radius: 12px;
          padding: 2rem;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .file-upload-area:hover {
          border-color: #3182ce;
          background: #f7fafc;
        }
        
        .file-input {
          display: none;
        }
        
        .upload-placeholder {
          color: #718096;
        }
        
        .preview-image {
          width: 100%;
          max-width: 200px;
          border-radius: 12px;
          margin: 0 auto;
          display: block;
        }
        
        @media (max-width: 768px) {
          .page-title {
            font-size: 1.5rem;
          }
          
          .profile-image {
            width: 100px;
            height: 100px;
          }
        }
      `}</style>
    </MyProSidebarProvider>
  );
};

export default Profile;